import React, { Suspense, useEffect, useState, useCallback } from "react";
import { routes } from "./routes";
import Router from "./components/Router";
import { ThemeProvider } from "@mui/material";
import { v4 } from "uuid";
import { getFromLocalStorage, setOnLocalStorage } from "./helpers/localStorage";
import { get, has } from "lodash";
import theme from "./theme";
import Loading from "./components/Loading";
import GeneralError from "./components/ErrorBoundary";
import { getCookie } from "./helpers/cookie";
import { RoleEnum } from "./models/role.types";
import Config from "Config";
import { ErrorBoundary } from "react-error-boundary";
import { LocalizationProvider } from "locale/localizationContext";

type AppProps = {};

export const App: React.FC<AppProps> = () => {
  const [isAppInitialized, setIsAppInitialized] = useState(false);
  const token = getCookie("token");
  const role = getCookie("role");

  useEffect(() => {
    if (!has(getFromLocalStorage(), "app-run-id")) {
      const uuid = v4();
      setOnLocalStorage({ "app-run-id": uuid });
    }
    setOnLocalStorage({
      "app-launch-count": get(getFromLocalStorage(), "app-launch-count", 0) + 1,
    });

    setIsAppInitialized(true);
  }, []);

  const fallback = useCallback(() => <GeneralError />, []);

  const computePermissions = useCallback(() => {
    const { roleScopes } = Config;
    let p = {};
    switch (role || "") {
      case RoleEnum.SUPERADMINISTRATOR:
        p = roleScopes.SUPERADMINISTRATOR;
        break;
      case RoleEnum.ADMINISTRATOR:
        p = roleScopes.ADMINISTRATOR;
        break;
      case RoleEnum.AGENT:
        p = roleScopes.AGENT;
        break;
      default:
        break;
    }

    return p;
  }, [role]);

  return (
    <Suspense fallback={<Loading />}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider loader={<Loading />}>
          {!isAppInitialized ? (
            <Loading />
          ) : (
            <ErrorBoundary fallbackRender={fallback}>
              <Router
                authorized={!!token && !!role}
                routes={routes}
                permissions={computePermissions()}
              />
            </ErrorBoundary>
          )}
        </LocalizationProvider>
      </ThemeProvider>
    </Suspense>
  );
};

export default App;
